var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',[_c('div',{staticClass:"custom-container"},[_c('container-charts',[_c('polar-area'),_c('distributed-columns'),_c('irregular-timeseries'),_c('distributed-columns-cargos')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }